import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import useTheme from "@mui/material/styles/useTheme";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import PlayArrow from "@mui/icons-material/PlayArrow";
import thumbnail from "../assets/yt32.webp";

const About = () => {
  const theme = useTheme();
  const introRef = useRef(null);
  const [loadVideo, setLoadVideo] = useState(false);

  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash === "#intro" && introRef.current) {
        const offsetTop = introRef.current.offsetTop - 100;
        window.scrollTo({ top: offsetTop, behavior: "smooth" });
        window.history.replaceState(null, null, " ");
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  const text1 = `
    Welcome to DirectCertify - your ultimate resource for exam preparation! Whether you're a student gearing up for an important test or a professional seeking certification, our comprehensive practice tests will be valuable and will boost your chances of success and guarantee it.
    <br/><br/>
    Best of luck in your exams!`;

  const text2 = `Get Successful with Our Practice Tests & Study Guides!`;

  const handleLoadVideo = () => {
    setLoadVideo(true);
  };

  return (
    <Box
      ref={introRef}
      id="intro"
      sx={{
        py: 12,
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Container maxWidth="lg">
        <Fade in={true} timeout={1000}>
          <Typography
            variant="h2"
            align="center"
            gutterBottom
            sx={{
              fontWeight: 700,
              mb: 8,
              fontSize: { xs: "28px", sm: "36px", md: "40px" },
              color: "black",
            }}
          >
            {text2}
          </Typography>
        </Fade>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Fade in={true} timeout={1500}>
              <Paper
                elevation={6}
                sx={{
                  borderRadius: 4,
                  overflow: "hidden",
                  aspectRatio: "16 / 9",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.02)",
                  },
                  position: "relative",
                }}
              >
                {!loadVideo ? (
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <img
                      // src="https://img.youtube.com/vi/C0KTKYuamy0/maxresdefault.jpg"
                      src={thumbnail}
                      alt="Video thumbnail"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)", // Slightly black overlay
                      }}
                    />
                    <Button
                      variant="contained"
                      aria-label="Play video"
                      startIcon={
                        <PlayArrow
                          sx={{
                            ml: 1,
                          }}
                        />
                      }
                      onClick={handleLoadVideo}
                      sx={{
                        backgroundColor: "red",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        "&:hover": {
                          backgroundColor: "#27b1bb",
                        },
                      }}
                    />
                  </div>
                ) : (
                  <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/C0KTKYuamy0?autoplay=1"
                    title="Directcertify Introduction - Practice Test Software and Exams PDF"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                )}
              </Paper>
            </Fade>
          </Grid>
          <Grid item xs={12} md={6}>
            <Fade in={true} timeout={2000}>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                  fontSize: { xs: "16px", sm: "18px", md: "18px" },
                  lineHeight: 1.4,
                  textAlign: { xs: "center", md: "justify" },
                  letterSpacing: "0rem",
                  "& br": { display: { xs: "none", sm: "inline" } },
                }}
                dangerouslySetInnerHTML={{ __html: text1 }}
              />
            </Fade>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;
